<template>

  
<div class="filter-page" @click.self="$emit('close')" >
  <div class="filter-comp">
    <div class="filter-headbar">
      <div class="filter-label">مرتب سازی</div>
      <div class="switch-comp" :style="{maxWidth:'188px'}">
        <button class="switch-comp-button" :class="{'active-opt':!query.descendingDate }"
                @click="query.descendingDate=false">قدیمی ترین
        </button>
        <button class="switch-comp-button" :class="{'active-opt':query.descendingDate }"
                @click="query.descendingDate=true">جدید ترین
        </button>
      </div>
    </div>
    <div class="filter-label"> ارز</div>
    <div class="coins-container">
      <div v-for="(coin,index) in supportingCoins.filter(a=> a[0] !== 'TOMAN')      " :key="index"  class="coin-box" :class="{'active-coin':query.coin===coin}" @click="query.coin=coin">
         <img :alt="$coinUnit[coin]+'icon'" class="icon" :src="require('../../../../assets/coins/'+coin[1].code+'.png')"/>
              <div class="coin-symbol-title">
                <div class="coin-title"> {{ coin[1].persianName }}</div>
                <div class="coin-symbol"> {{ coin[1].code }}</div>
          </div>
        
      </div>
    </div>
    <div class="filter-label"> بازه زمانی</div>
    <div class="dates">
       <calendar @value="(value)=>query.startDate=value"  dateId="start" label="تاریخ شروع"/>
       <calendar @value="(value)=>query.endDate=value" dateId="end" label="تاریخ پایان"/>
    </div>
    <button class="confirm-btn" @click="filterSubmit()">ثبت فیلترها</button>
  </div>
</div>


</template>

<script>
// import dataSet from './dataSet.json'
import Calendar from "@/views/tools/Calendar";
export default {
  components:{
    Calendar
  },
  name: "TransactionsTable",
  data() {
    return {
      coins:[
        'BITCOIN',
        'ETHEREUM',
        'BITCOIN_CASH',
        'STELLAR',
        'MATIC',
        'CELO',
        'DOGE_COIN',
        'TETHER',
        'LITE_COIN',
      ],
      filtersShow:false,
      supportingCoins:[],
      query:{
        startDate:'',
        endDate:'',
        coin:{
          code:'BTC',
          coin:'BITCOIN',
          persianName:'بیتکوین'
        },
        descendingDate:true
      }

     
    }
  },

  methods: {
    // filterTransactions(transactions) {
    //   return transactions.filter(transaction => {
    //     if (transaction.transType === this.transactionsType) {
    //       return transaction
    //     }
    //   })
    // },
    filterSubmit(){
      console.log(this.query)
      this.$emit('filterSelect',this.query);
      this.$emit('close')
    },
      async getSupportingCoins() {
    const res  = await this.$axios.get('/coins/supporting-coins')
    this.supportingCoins = res


let coins= Object.entries(this.supportingCoins)
    // coins = for([key,value] of Object.entries(this.supportingCoins)){
    // key.coin !== 'TOMAN'
    
    // }


this.supportingCoins = coins

  },
  changeToArray(){
    this.supportingCoins = [this.supportingCoins]
    console.log(this.supportingCoins)
  }
  },

mounted(){
  this.getSupportingCoins()
}

}

</script>

<style scoped>
.active-coin{
  background: rgba(215, 200, 200, 0.12);
}
.dates{
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  justify-content: space-between;
  row-gap: 15px;
}

.dates > div{
  /*max-width: 308px;*/
}
.confirm-btn{
  background: linear-gradient(181.54deg, #1199FA 1.31%, #123249 180.79%);
  border-radius: 4px;
  height: 35px;
  width: 100%;
  color: white;
}
.filter-label{
  color: #FFFFFF;
  font-size: clamp(14px,1.5vw,16px);
  font-weight: bold;
}
.filter-comp{
  display:flex;
  row-gap: 40px;
  flex-direction: column;
  padding: clamp(18px,2.5vw,32px);
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(40px);
  border-radius: 20px;
  max-width: 700px;
  margin-bottom: 60px;
}

.filter-headbar{
  display: flex;
  column-gap: 10px;
  align-items: center;
  row-gap: 15px;
  flex-wrap: wrap;
}

.switch-comp {
  display: flex;
  align-items: center;
  column-gap: 7px;
  min-width: 150px;
  flex-grow: 1;
}

.switch-comp-button {
  background: transparent;
  color: rgba(215, 200, 200, 1);
  border-radius: 4px;
  border: 1px solid rgba(215, 200, 200, 0.35);
  cursor: pointer;
  font-size: clamp(10px, 1.1vw, 12px);
  height: 25px;
  flex-grow: 1;
}
.filter-page{
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: fixed;
  padding: 90px  25px 0 25px;

  /*border: 1px solid white;*/
  /* width:100%;*/
  /*height:100%;*/
  overflow-y:scroll;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
}

.coin-title{
  color: #D7C8C8;
  font-size: clamp(14px,1.5vw,16px);
}
.coin-symbol{
  color: #D7C8C8;
  font-size: clamp(8px,1vw,10px);
}

.active-opt {
  background: rgba(215, 200, 200, 0.12) !important;
  color: rgba(17, 153, 250, 1) !important;
}

.coin-box{
  border: 1px solid #D7C8C8;
  color: #D7C8C8;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  max-width:134px;
  padding: 8px 12px;

  height: 49px;
  display: flex;
  column-gap: 12px;
  align-items: center;
}

.coin-box img{
  width: 32px;
  height: 32px;
}

.icon{
  width: clamp(25px,2.7vw,32px);
  height: clamp(25px,2.7vw,32px);
}
.coins-container{
  max-height: 300px;
  overflow: scroll;
  display: flex;
  row-gap: 16px;
  flex-wrap: wrap;
  column-gap: 16px;
}


</style>